/*
 * Copyright (c) 2023 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

import { server, radiusEndpointBase, remoteManagerEndpointBase } from "./Endpoint";

const common = {
  server: server,
  radiusEndpointBase: radiusEndpointBase,
  remoteManagerEndpointBase: remoteManagerEndpointBase,
};

const production = {
  ...common,
  routeBase: "/guest-data",
  debug: false
};

const development = {
  ...common,
  routeBase: "",
  debug: true
};

export const constants = process.env.NODE_ENV === "development" ? development : production;
